import '../assets/images/fav.png';
import '../assets/images/map.png';
import '../assets/images/map_big_ru.svg';
import '../assets/images/map_small_ru.svg';
import '../assets/images/map_big_en.svg';
import '../assets/images/map_small_en.svg';
import '../assets/images/map_big_pl.svg';
import '../assets/images/map_small_pl.svg';
import '../assets/images/map_big_uz.svg';
import '../assets/images/map_small_uz.svg';
import '../assets/images/promo1.jpg';
import '../assets/images/promo2.jpg';
import '../assets/images/promo3.jpg';
import '../assets/images/pixel.jpg';
import '../assets/images/share.jpg';
import '../assets/images/frch2-video-preview.jpg';
import '../assets/images/frch2-video-preview2.jpg';
import '../assets/images/rafal_video.jpg';

import '../assets/images/history_en.jpg';
import '../assets/images/history_pl.jpg';
import '../assets/images/history_ru.jpg';
import '../assets/images/history_fa.jpg';
import '../assets/images/history_uz.jpg';

import '../assets/images/services/indoor.jpg';
import '../assets/images/services/outdoor.jpg';
import '../assets/images/services/special.jpg';

import '../assets/images/logos/1.png';

import '../assets/images/cases/1.jpg';
import '../assets/images/cases/2.jpg';
import '../assets/images/cases/3.jpg';
import '../assets/images/cases/4.jpg';
import '../assets/images/cases/5.jpg';
import '../assets/images/cases/6.jpg';
import '../assets/images/cases/7.jpg';
import '../assets/images/cases/8.jpg';
import '../assets/images/cases/9.jpg';

import '../assets/images/previews/1.jpg';
import '../assets/images/previews/1b.jpg';
import '../assets/images/previews/2.jpg';
import '../assets/images/previews/2b.jpg';
import '../assets/images/previews/3.jpg';
import '../assets/images/previews/3b.jpg';

import '../assets/images/team/1.jpg';
import '../assets/images/team/1b.jpg';
import '../assets/images/team/2.jpg';
import '../assets/images/team/3.jpg';
import '../assets/images/team/4.jpg';
import '../assets/images/team/5.jpg';

import '../assets/images/clients/1.png';
import '../assets/images/clients/2.png';
import '../assets/images/clients/3.jpg';
import '../assets/images/clients/4.jpg';
import '../assets/images/clients/5.jpg';
import '../assets/images/clients/6.png';
import '../assets/images/clients/7.png';
import '../assets/images/clients/8.png';
import '../assets/images/clients/9.jpg';
import '../assets/images/clients/10.jpg';
import '../assets/images/clients/11.jpg';
import '../assets/images/clients/12.png';
import '../assets/images/clients/13.png';
import '../assets/images/clients/14.png';
import '../assets/images/clients/15.png';
import '../assets/images/clients/16.png';
import '../assets/images/clients/17.png';
import '../assets/images/clients/18.png';
import '../assets/images/clients/19.png';
import '../assets/images/clients/20.png';
import '../assets/images/clients/21.png';
import '../assets/images/clients/22.png';

import '../assets/images/cases/ekb.jpg';
import '../assets/images/cases/msk.jpg';
import '../assets/images/cases/spb.jpg';

import '../assets/images/frch2/1.jpg';
import '../assets/images/frch2/2.jpg';
import '../assets/images/frch2/3.jpg';
import '../assets/images/frch2/5.jpg';
import '../assets/images/frch2/4.jpg';
import '../assets/images/frch2/6.jpg';

import '../assets/images/map_branch.svg';
import '../assets/images/branch/main-bg.jpg';

import '../assets/images/branch/cases/i1.png';
import '../assets/images/branch/cases/i2.png';
import '../assets/images/branch/cases/i3.png';
import '../assets/images/branch/cases/i4.png';
import '../assets/images/branch/cases/i5.png';
import '../assets/images/branch/cases/i6.png';
import '../assets/images/branch/cases/i7.png';
import '../assets/images/branch/cases/i8.png';

import '../assets/images/branch/cases/01.jpg';
import '../assets/images/branch/cases/02.jpg';
import '../assets/images/branch/cases/03.jpg';
import '../assets/images/branch/cases/04.jpg';
import '../assets/images/branch/cases/05.jpg';
import '../assets/images/branch/cases/06.jpg';
import '../assets/images/branch/cases/07.jpg';
import '../assets/images/branch/cases/08.jpg';
import '../assets/images/branch/cases/09.jpg';
